import { useState, useEffect, useCallback } from "react";

// Gets a component's height during window resize events
// Props: an optional initial height value, and the component's ID
export function useComponentDimensionsById(
  initialValue = undefined,
  componentId
) {
  const [dynamicWidth, setDynamicWidth] = useState(initialValue);
  const [dynamicHeight, setDynamicHeight] = useState(initialValue);

  const updateComponentHeight = useCallback(() => {
    const element = document.querySelector(componentId);

    if (element) {
      const rect = element.getBoundingClientRect();
      const height = rect?.height; // Includes padding and borders
      const width = rect?.width;
      setDynamicHeight(height);
      setDynamicWidth(width);
    }
  }, [componentId]);

  useEffect(() => {
    updateComponentHeight();
    window.addEventListener("resize", updateComponentHeight);

    return () => {
      window.removeEventListener("resize", updateComponentHeight);
    };
  }, [updateComponentHeight]);

  return { dynamicHeight, dynamicWidth };
}
